import React from 'react'

const MobileHeader = ({ projectStore }) => {
  const { project } = projectStore
  return <div className='mobile-project-header'>{project.projectName}</div>
}

export default MobileHeader
